// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3e6wd","infoBtn":"quickbooks_infoBtn__2oEAS","formBox":"quickbooks_formBox__3Q1sE","formFooter":"quickbooks_formFooter__2H4-q"};